import React, { FC } from 'react';
import Link from 'next/link';
import Typo from '../../Typography';
import DotSeparator from './DotSeparator';
import { TCommentOrigin } from '../types';

type TCommentOriginProps = {
  origin?: TCommentOrigin;
};

export const CommentOrigin: FC<TCommentOriginProps> = ({ origin = 't2' }) => {
  const linksData = {
    t2: {
      description: '',
      href: '',
    },
  };

  const linkData = linksData[origin];

  if (!linkData.href || !linkData.description) {
    return null;
  }

  return (
    <>
      <DotSeparator />
      <div className="flex gap-1">
        <Typo text="via" className="text-gray-700 align-self-start" />
        <Link href={linkData.href} target="_blank" className="underline cursor-pointer text-gray-700 align-self-start">
          {linkData.description}
        </Link>
      </div>
    </>
  );
};
